module.exports = __webpack_public_path__ + "6f52390baa6df6ff3ee3b610800bed5e.MP3";